import React from 'react'
import Grid from '@material-ui/core/Grid'
import SlaComponent from 'components/Apps/SlaMonitor/Sla'
import CageSla from './CageSla'

function Sla() {
  return (
    <>
      <Grid item lg={6} md={12} sm={12} xs={12}>
        <SlaComponent />
      </Grid>

      <Grid item lg={6} md={12} sm={12} xs={12}>
        <CageSla />
      </Grid>
    </>
  )
}

export default Sla
